import { DEFAULT_ACCOUNT_SETTINGS, SettingsResponse } from '@business/entities/settings';
import { SettingsConfig } from '@core/utils/config';
import * as React from 'react';
import { useSubscribe } from '../rxjs';

export function useSettings(options: { onChange?: (info: SettingsResponse | null) => void } = {}) {
  const currentValue = SettingsConfig.changed$.value;
  const [setting, setSettings] = React.useState<SettingsResponse | null>(currentValue);

  const callback = options.onChange;

  const callbackRef = React.useRef(callback);

  callbackRef.current = callback;

  useSubscribe(SettingsConfig.changed$, newSettings => {
    setSettings(newSettings);
    if (callbackRef.current) callbackRef.current(newSettings);
  });

  return setting;
}

export function useAccountSettings() {
  const settings = useSettings();
  return settings ? settings.accountSettings : DEFAULT_ACCOUNT_SETTINGS;
}

export function useTmSettings() {
  const settings = useSettings();
  return settings ? settings.tm : null;
}

export function useIsVendastaAccount() {
  const settings = useSettings();
  return settings ? settings.isExternalAccount : false;
}

export function useSchedularSettings() {
  const settings = useSettings();
  return settings ? settings.schedular : null;
}
